import { render } from "./appbartitle.vue?vue&type=template&id=f2ab0a26&scoped=true"
const script = {}

import "./appbartitle.vue?vue&type=style&index=0&id=f2ab0a26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2ab0a26"]])

export default __exports__